import React, { useState } from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = (e) => {
    console.log('Image failed to load:', src);
    setHasError(true);
    setIsLoading(false);
    e.target.src = "/assets/images/no_image.png";
  };

  const handleLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  // If no src provided, show fallback immediately
  if (!src) {
    return (
      <img
        src="/assets/images/no_image.png"
        alt={alt}
        className={className}
        {...props}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
      {...props}
    />
  );
}

export default Image;
